import React from "react";

import { Col, FormLabel, Row } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import {
  CustomerAndFabricSalesDetailPrintRequest,
  CustomerInvoiceInquiryCriteriaBean,
  CustomerSalesDataRequest,
  CustomerSearchCriteria,
  FabricStyleSearchCriteria,
  PageListBean,
  RestCustomerListRequest,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestReadRequest,
} from "../ds/ds.js";
import {
  AlertToolBox,
  CollapseComponent,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
  ColumnDefinition,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupCustomerModule,
  PopupFabricStyleModule,
  PopupInvoiceModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { ReportService } from "../services/ReportService.js";
import CustomTable from "../gui_components/CustomTable.js";
class CustomerAndFabricSales extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Customer & Fabric Sales Detail Inquiry ",
      criteria: new CustomerInvoiceInquiryCriteriaBean(),
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: false,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowExitButton: true,
      error_list: new Array(),
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      customerLookupHandler: null,
      fabricLookupHandler: null,
      isShowAlert: false,
      alertMessage: new Array(),
      success_list: new Array(),
      moduleForPopup: new Array(),
      customerSalesDataList: new Array(),
      isShowInvoiceModule: false,
      isShowFabricStyleModule: false,
      isShowCustomerModule: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isShowColorLookup: false,
      colorLookupHandler: null,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricPageListForAutoCompleteList: new Array(),
      customerPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCustomerList: false,
      showAutoCompleteFabricList: true,
      showAutoCompleteFabricColorList: true,
      isDisabledFields: false,
      customerLookup: true,
      fabricLookup: true,
      isCollapsible_open: true,
      inquiryDataList: null,
      is3PL: false,
      isShowShortCutPopupCriteriaView: false,
    };
    this.fabricCodeRef = React.createRef();
    this.customerCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.initLookupHandlers();

    if (
      this.props.customerCode !== "" &&
      this.props.customerCode !== undefined
    ) {
      let criteria = this.state.criteria;
      criteria.customerCode = this.props.customerCode;
      this.setState({
        criteria: criteria,
      });
    }
    if (this.props.fabricCode !== "" && this.props.fabricCode !== undefined) {
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = this.props.fabricCode;
      this.setState({
        criteria: criteria,
      });
      // this.loadPage(1);
    }
    console.log("this.props..", this.props);
    console.log("this.props..", this.props.customerCode);

    if (
      !isEmptyString(this.props.customerCode) ||
      !isEmptyString(this.props.fabricCode)
    ) {
      this.loadPage(1);
      this.setState({
        isShowShortCutPopupCriteriaView: true,
        isShowResetButton: false,
        isShowExecuteButton: false,
        isShowClearCriteriaButton: false,
      });
    }
  }
  initLookupHandlers = () => {
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisabledFields: true,
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  loadPage = () => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing ...",
    });
    if (
      !isEmptyString(criteria.customerCode) ||
      !isEmptyString(criteria.fabricStyleCode)
    ) {
      let pageInput = new PageListBean();
      pageInput.currentPage = 1;
      let listRequest = new CustomerSalesDataRequest();
      listRequest.criteria = criteria;
      listRequest.pageInput = pageInput;
      console.log("listRequest..", listRequest);
      this.loadCustomerSalesHistoryList(listRequest);
    } else {
      let errMsg = "";
      if (!this.state.is3PL) {
        errMsg = "CustomerCode/FabricCode is Required";
      } else {
        errMsg = "CustomerCode/ItemCode is Required";
      }
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  loadCustomerSalesHistoryList = (listRequest) => {
    if (SecurityAccessManager.CustomerAndFabricSalesInquiry_IsAccessible()) {
      ReportService.getCustomerSalesData(
        listRequest,
        this.loadCustomerSalesDetailPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadCustomerSalesDetailPageResponse = (response) => {
    console.log("response.. #", response);
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.salesDataPageList != null) {
      let resultList = new Array();
      let inquiryDataList = response.data.salesDataPageList;
      if (!isEmptyArray(response.data.salesDataPageList.fabricStyleSales)) {
        resultList = response.data.salesDataPageList.fabricStyleSales;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        customerSalesDataList: resultList,
        inquiryDataList: inquiryDataList,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        customerLookup: false,
        fabricLookup: false,
        isShowColorLookup: false,
        isCollapsible_open: false,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  errorCallBack = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error : " + error);
  };
  generatePDF = () => {
    this.generateCustomerSalesReport(1);
  };
  generateExcel = () => {
    this.generateCustomerSalesReport(2);
  };
  generateCustomerSalesReport = (reportType) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating ...",
    });
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let criteria = this.state.criteria;
    let requestInput = new CustomerAndFabricSalesDetailPrintRequest();
    requestInput.criteria = criteria;
    requestInput.input = reportBean;
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.CustomerAndFabricSalesInquiryPDFReport_IsAccessible()
      ) {
        ReportService.generateCustomerAndFabricSalesDetailPrintReport(
          requestInput,
          this.generateCustomerSalesReportResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.CustomerAndFabricSalesInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generateCustomerAndFabricSalesDetailPrintReport(
          requestInput,
          this.generateCustomerSalesReportResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateCustomerSalesReportResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  generateCustomerSalesReportResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
         let reportFilePath = response.data.reportResult.reportFileID;
            let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new CustomerInvoiceInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    criteria.fabricStyleName = "";
    this.setState({
      criteria: criteria,
      isDisabledFields: false,
      isCollapsible_open: true,
      inquiryDataList: null,
      isShowColorLookup: false,
    });
    this.hideAlertCallBack();
  };
  resetInquiry = () => {
    let criteria = new CustomerInvoiceInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    criteria.fabricStyleName = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      customerSalesDataList: new Array(),
      isShowColorLookup: false,
      fabricColourPageListForAutoCompleteList: new Array(),
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisabledFields: false,
      customerLookup: true,
      fabricLookup: true,
      isCollapsible_open: true,
      inquiryDataList: null,
      isShowColorLookup: false,
    });
    this.hideAlertCallBack();
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  viewInvoiceModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewFabricModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricStyleModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewCustomerModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowInvoiceModule: isOpen,
      isShowFabricStyleModule: isOpen,
      isShowCustomerModule: isOpen,
      moduleForPopup: [],
    });
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteFabricList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricList: showAutoCompleteList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
        colorList: [],
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        let colors = fabricStyle.colors;
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color"
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowColorLookup: true,
            criteria: criteria,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readandsetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.errorCallBack
    );
  };
  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.errorCallBack
    );
  }
  readByFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
    this.readandsetFabricStyleDetail(fabricStyleCode);
    this.setState({ fabricPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteList });
  };
  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let colorCode = e.target.value;
    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.criteria;
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "colorCode" &&
      showAutoCompleteFabricColorList === true &&
      colorCode !== ""
    ) {
      this.readFabricColourBySearchString(e.target.value);
    }
  };
  readFabricColourBySearchString(searchString) {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;

    criteria.colorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    let fabricStyleColourCode = e.target.value;
    this.fabricStyleColorSelected(fabricStyleColourCode);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (colorCode) => {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    criteria.colorCode = colorCode; //Added line
    this.setState({ criteria: criteria });
  };
  onCustomerCodeChange = (e) => {
    let customerCode = e.target.value;
    this.state.isShowAutoCompleteCustomerList = true;
    let tempData = this.state.criteria;
    let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.isShowAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
      let tempData = this.state.criteria;
      tempData.customerCode = "";
      tempData.customerName = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        criteria: tempData,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      setTimeout(() => {
        this.readCustomerBySearchString(e.target.value);
      }, 200);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ criteria: tempData });
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 10;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readCustomerBySearchCodeResponse,
      this.errorCallBack
    );
  }
  readCustomerBySearchCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readCustomerByCustomerCode(customerCode);
    this.state.isShowAutoCompleteCustomerList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayAutoCustomerCompleteList = (showAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteCustomerList: showAutoCompleteList,
    });
  };
  readCustomerByCustomerCodeResponse = (response) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading ...",
    });
    let customerData = response.data.customer;
    let criteria = this.state.criteria;
    criteria.customerCode = customerData.code;
    criteria.customerName = customerData.description;
    this.setState({
      criteria: criteria,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readCustomerByCustomerCode = (customerCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = customerCode;
    CustomerService.readCustomerWithChildren(
      readrestInput,
      this.readCustomerByCustomerCodeResponse,
      this.errorCallBack
    );
  };
  showHideSecondHeader = (e) => {
    if (e.detail === 1) {
      let isCollapsible_open = !this.state.isCollapsible_open;
      this.setState({ isCollapsible_open: isCollapsible_open });
    }
  };
  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer#", "customerCode", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "customerName", true)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Date", "invoiceDate", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice#", "invoiceNumber", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewInvoiceModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Cust P.O#", "customerPurchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item#" : "FabricStyle#",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "6", "", "wt-6", "wt-6")
        .setClickDetails(true, false, this.viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item Name" : "FabricStyle Name",
          "fabricStyleName",
          true
        )
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Price", "price", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Inv Qty", "invoicedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Net Amt", "lineNetAmount", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Total Amt", "lineTotalAmount", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    return columns;
  };
  render() {
    let customerSalesDataList = this.state.customerSalesDataList;
    return (
      <div>
        {" "}
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={
            this.state.is3PL
              ? "Customer & Item Sales Detail Inquiry"
              : "Customer & Fabric Sales Detail Inquiry"
          }
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
          onModuleExit={this.onModuleExit}
        />
        <CriteriaView
          {...this.state}
          onChange={this.onChange}
          onCustomerCodeChange={this.onCustomerCodeChange}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCustomerCompleteList={this.displayAutoCustomerCompleteList}
          fabricCodeOnChange={this.fabricCodeOnChange}
          fabricCodeRef={this.fabricCodeRef}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
          fabricColourEnterKeyEventHandler={
            this.fabricColourEnterKeyEventHandler
          }
          displayAutoCompleteFabricColorList={
            this.displayAutoCompleteFabricColorList
          }
          onFabricColourCodeChange={this.onFabricColourCodeChange}
          showHideSecondHeader={this.showHideSecondHeader}
        />
        {this.state.isInquiryDatasFound && (
          <div className="mt-3">
            <CustomTable
              data={customerSalesDataList}
              columns={this.inquiryColumns()}
            />
          </div>
        )}
      </div>
    );
  }
}
export function CriteriaView(props) {
  const onChange = (e) => props.onChange(e);
  let fabricLookupHandler = props.fabricLookupHandler;
  let customerLookupHandler = props.customerLookupHandler;
  const fabricCodeOnChange = (e) => props.fabricCodeOnChange(e);
  const onFabricColourCodeChange = (e) => {
    props.onFabricColourCodeChange(e);
  };
  const fabricEnterKeyEventHandler = (e) => {
    props.fabricEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricList = () => {
    props.displayAutoCompleteFabricList();
  };
  const fabricColourEnterKeyEventHandler = (e) => {
    props.fabricColourEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricColorList = () => {
    props.displayAutoCompleteFabricColorList();
  };
  const onCustomerCodeChange = (e) => props.onCustomerCodeChange(e);
  const customerCodeEnterKeyEventHandler = (e) =>
    props.customerCodeEnterKeyEventHandler(e);
  const displayAutoCustomerCompleteList = (list) =>
    props.displayAutoCustomerCompleteList(list);
  let criteria = props.criteria;
  const fabricCodeRef = props.fabricCodeRef;
  const customerCodeRef = props.customerCodeRef;

  return (
    <div>
      {props.isShowShortCutPopupCriteriaView ? (
        <Row className="d-flex justify-content-left">
          <Col sm="1">
            {" "}
            <FormLabel>Customer</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              // ref={customerCodeRef}
              name="customerCode"
              onChange={onCustomerCodeChange}
              value={criteria.customerCode}
              disabled={props.isDisabledFields}
            />
          </Col>
          {!isEmptyString(props.criteria.fabricStyleCode) ? (
            <>
              <Col sm="1">
                {props.is3PL ? (
                  <FormLabel>Item</FormLabel>
                ) : (
                  <FormLabel>FabricStyle</FormLabel>
                )}
              </Col>
              <Col sm="2">
                <InputTextbox
                  ref={fabricCodeRef}
                  name="fabricStyleCode"
                  onChange={fabricCodeOnChange}
                  value={criteria.fabricStyleCode}
                  disabled={props.isDisabledFields}
                />
              </Col>
            </>
          ) : null}

          {props.isInquiryDatasFound && (
            <>
              <Col sm="1">
                {" "}
                <FormLabel>Total Sales</FormLabel>
              </Col>

              <Col sm="2">
                {" "}
                <InputTextbox
                  name="totalInvoiceAmount"
                  className="summary_input"
                  value={props.inquiryDataList.totalInvoiceAmount}
                  disabled={true}
                />
              </Col>
            </>
          )}
        </Row>
      ) : (
        <>
          <Row className="d-flex justify-content-left">
            <Col sm="1">
              {" "}
              <FormLabel>Customer</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={customerCodeRef}
                name="customerCode"
                onChange={onCustomerCodeChange}
                value={criteria.customerCode}
                lookupRequired={props.customerLookup}
                lookupHandler={customerLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={customerCodeEnterKeyEventHandler}
                autoCompleteListData={props.customerPageListForAutoCompleteList}
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={displayAutoCustomerCompleteList}
                showAutoCompleteList={props.isShowAutoCompleteCustomerList}
                disabled={props.isDisabledFields}
              />
            </Col>
            <Col sm="3">
              <InputTextbox
                name="customerName"
                onChange={onChange}
                value={criteria.customerName}
                disabled={true}
              />
            </Col>

            <Col sm="1">
              {props.is3PL ? (
                <FormLabel>Item</FormLabel>
              ) : (
                <FormLabel>FabricStyle</FormLabel>
              )}
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={fabricCodeRef}
                name="fabricStyleCode"
                onChange={fabricCodeOnChange}
                value={criteria.fabricStyleCode}
                lookupRequired={props.fabricLookup}
                lookupHandler={fabricLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={fabricEnterKeyEventHandler}
                autoCompleteListData={props.fabricPageListForAutoCompleteList}
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={displayAutoCompleteFabricList}
                showAutoCompleteList={props.showAutoCompleteFabricList}
                disabled={props.isDisabledFields}
              />
            </Col>

            <Col sm="2">
              <InputTextbox
                name="fabricStyleName"
                onChange={onChange}
                value={criteria.fabricStyleName}
                disabled={true}
              />
            </Col>

            <Col>
              <CollapseComponent
                isOpen={props.isCollapsible_open}
                onClick={(e) => props.showHideSecondHeader(e)}
              />
            </Col>
          </Row>
          {props.isCollapsible_open && (
            <Row>
              <Col sm="1">
                {" "}
                <FormLabel>Color</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={onFabricColourCodeChange}
                  name="colorCode"
                  value={criteria.colorCode}
                  lookupRequired={props.isShowColorLookup}
                  lookupHandler={props.colorLookupHandler}
                  enterKeyEventHandler={fabricColourEnterKeyEventHandler}
                  autoCompleteListData={
                    props.fabricColourPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={displayAutoCompleteFabricColorList}
                  showAutoCompleteList={props.showAutoCompleteFabricColorList}
                  disabled={!props.isShowColorLookup}
                />
              </Col>

              {props.isInquiryDatasFound && (
                <Col sm="1">
                  {" "}
                  <FormLabel>Total Sales</FormLabel>
                </Col>
              )}
              {props.isInquiryDatasFound && (
                <Col sm="2">
                  {" "}
                  <InputTextbox
                    name="totalInvoiceAmount"
                    className="summary_input"
                    value={props.inquiryDataList.totalInvoiceAmount}
                    disabled={true}
                  />
                </Col>
              )}
            </Row>
          )}
        </>
      )}
    </div>
  );
}
function CustomerAndFabricSalesInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <CustomerAndFabricSales {...props} name="" /> <br />
    </div>
  );
}

export default CustomerAndFabricSalesInquiry;
